import React from 'react'
import { Text } from '@chakra-ui/react'

const DescriptionText = ({ children }: { children: React.ReactNode }) => {
  return (
    <Text
      textStyle={'loginText'}
      my={6}
      textAlign={'center'}
      maxW={'25rem'}
      mx={'auto'}
    >
      {children}
    </Text>
  )
}

export default DescriptionText
